import fire from '@store/firebase';
import { IQuest } from '@typings/quest/questTypes';
import { getAllDocsLength } from '@store/firebase/counter';

const firestore = fire.firestore();

export async function addAndGetDocId({ ref, data }) {
  return ref
    .add({
      ...data,
      createdAt: new Date(),
      updatedAt: new Date(),
    })
    .then((res) => res.id)
    .catch((err) => console.log(err.message));
}

export type UpdateQuestProps = {
  data: Partial<IQuest>;
  collectionPath?: string; // default: 'quest'
  docId?: string;
};

function sanitize<T extends Record<string, any>>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj || {}).filter(([_, v]) => v !== undefined),
  ) as T;
}

export async function updateQuest({ data, collectionPath = 'quest', docId }: UpdateQuestProps) {
  const ref = firestore.collection(collectionPath);
  const currentDocsLength = await getAllDocsLength(collectionPath);

  const cleanData = sanitize(data || {});

  let _docId: string = docId || '';
  if (!_docId) {
    _docId = await addAndGetDocId({ ref, data: cleanData });
  }

  const newData: Partial<IQuest> = sanitize({
    ...cleanData,
    updatedAt: new Date(),
    priority: (cleanData as any).priority ?? currentDocsLength,
    id: _docId,
  });

  await ref.doc(_docId).set(newData, { merge: true }).catch((err) => console.log(err.message));

  return _docId;
}
